import { Component } from '@angular/core';
import { UserService } from 'src/app/shared/user.service';
import * as echarts from 'echarts';
import { Chart } from 'chart.js';
@Component({
  selector: 'app-report-chart',
  templateUrl: './report-chart.component.html',
  styleUrl: './report-chart.component.css'
})
export class ReportChartComponent {
  statusLabel: any[] = [];
  statusValue: any[] = [];
  chart:any


  constructor(private userService:UserService){}
  async ngAfterViewInit() {


    await this.userService.getTurnAroundTime().subscribe((res :any )=>{
      let data = res.body
      for (let index = 0; index < data.length; index++) {
        if (data[index].value !== null) {
          this.statusLabel.push(data[index].contractTypeName);
          this.statusValue.push(data[index].avgTurnAroundDays);
        }
      }
      this.contractBystatus(this.statusLabel,this.statusValue)
  
    })
  }
contractBystatus(statusLabel: any, statusValue: any) {
  this.chart = echarts.init(document.getElementById('barChart'));

  const option = {
    dataset: {
      source: statusLabel.map((label, index) => ({ score: statusValue[index], amount: statusValue[index], product: label })),
    },
    grid: {
      containLabel: false
    },
    xAxis: { name: 'Days' },
    yAxis: {
      type: 'category',
      data: statusLabel,
      axisLabel: {
        interval: 0,
        rotate: 20,
        width: 80,
        lineHeight: 20,
        overflow: 'truncate',
        textStyle: {
          fontFamily: 'Poppins',
          fontSize: 12
        }
      },
      nameTruncate: {
        maxWidth: 2,
        ellipsis: '...',
        placeholder: '.',
      },
    },
    series: [{
      name: 'Direct',
      type: 'bar',
      data: statusValue,
      animation: true,
      animationDuration: 2000,
      animationEasing: 'BounceIn',
      label: {
        show: true,
        position: 'top',
        color: 'black',
        textStyle: {
          fontFamily: 'Poppins'
        }
      },
      barWidth: 40, // Set the width of the bars
      barCategoryGap: '0%', // Reduce the gap between bars
    }],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow' // Show tooltip at the position of the mouse pointer
      }
    },
    toolbox: {
      show: true,
      feature: {
        dataView: { readOnly: false },
        saveAsImage: {}
      }
    },
    title: {
      text: 'Agreement Turnaround Time',
      left: 'center',
      textStyle: {
        color: '#444',
        fontSize: 20,
        fontWeight: 'bold',
        fontFamily: 'Poppins'
      }
    },
    itemStyle: {
      color: function (params) {
        return params.value > 0 ? '#65B581' : '#FD665F'; // Custom color based on value
      }
    }
  };
  
  

  this.chart.setOption(option);
}

}
